import { Injectable } from '@angular/core';
import { get } from 'lodash';

import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { SmartAssistService } from 'src/app/services/smart-assist/smart-assist.service';
import { IDeviceSettingsDefaultValueService } from '../../device-settings-default-value.interface';
import { ActiveProtectionSensitivity } from 'src/app/enums/active-protection-sensitivity.enum';

@Injectable({
  providedIn: 'root'
})

export class ActiveProtectionSystemDefaultValueService implements IDeviceSettingsDefaultValueService {
	constructor(
	  private smartAssist: SmartAssistService,
	  private logger:LoggerService,
	) { }

	initialize(adTags: any): void {
		const activeProtectionSystem = get(adTags, DeviceSettingsFeatureToggle.SmartAssistActiveProtectionSystem);
		const isADPolicyEnabled = activeProtectionSystem === ADPolicyState.ENABLED;
		const isShellAvailable = this.smartAssist.isShellAvailable;

		if(isADPolicyEnabled && isShellAvailable) {
			this.resetDefaultValues();
		}
	}

	private async resetDefaultValues(): Promise<any> {
		try {
			const isAPSAvaiable = await this.smartAssist.getAPSCapability();
			if(isAPSAvaiable) {
				this.setDefaultAPSMode();
				this.setDefaultAutoDisableSetting();
				this.setDefaultAPSSensitivityLevelValue();
				this.setDefaultManualSnooze();
				this.setDefaultPenSetting();
				this.setDefaultTouchInputSetting();
				this.setDefaultPSensorSetting();
			}
		} catch (error) {
			this.logger.error('resetDefaultValue: ', error);
		}
	}

	private async setDefaultAPSMode(): Promise<any> {
		try {
			await this.smartAssist.setAPSMode(true);
		} catch (error) {
			this.logger.error('setDefaultAPSMode: ', error);
		}
	}

	private async setDefaultAPSSensitivityLevelValue(): Promise<any> {
		try {
			await this.smartAssist.setAPSSensitivityLevel(ActiveProtectionSensitivity.High);
		} catch (error) {
			this.logger.error('setDefaultAPSMode: ', error);
		}
	}

	private async setDefaultAutoDisableSetting(): Promise<any> {
		try {
			await this.smartAssist.setAutoDisableSetting(false);
		} catch (error) {
			this.logger.error('setDefaultAutoDisableSetting: ', error);
		}
	}

	private async setDefaultManualSnooze(): Promise<any> {
		try {
			await this.smartAssist.setSnoozeSetting(false);
		} catch (error) {
			this.logger.error('setDefaultAutoDisableSetting: ', error);
		}
	}

	private async setDefaultPenSetting(): Promise<any> {
		try {
			const isPenSettingsAvaiable = await this.smartAssist.getPenCapability();
			if(isPenSettingsAvaiable) {
				await this.smartAssist.setPenSetting(false);
			}
		} catch (error) {
			this.logger.error('setDefaultPenSetting: ', error);
		}
	}

	private async setDefaultTouchInputSetting(): Promise<any> {
		try {
			const isTouchInputSettingAvaiable = await this.smartAssist.getTouchCapability();
			if(isTouchInputSettingAvaiable) {
				await this.smartAssist.setTouchInputSetting(false);
			}
		} catch (error) {
			this.logger.error('setDefaultTouchInputSetting: ', error);
		}
	}

	private async setDefaultPSensorSetting(): Promise<any> {
		try {
			const isPSensorSettingAvaiable = await this.smartAssist.getPSensorCapability();
			if(isPSensorSettingAvaiable) {
				await this.smartAssist.setPSensorSetting(false);
			}
		} catch (error) {
			this.logger.error('setDefaultPSensorSetting: ', error);
		}
	}
}
